import { useEffect, useState } from "react";
import { getInstantWinData } from "./dreamCar-service";
import { InstantWinProps } from "./macros/ourCars/types";
import styles from "./macros/ourCars/ourCars.module.css";
import { showInstantWinTabContent, showPrizeTabContent } from "./utils";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { publishActiveTab } from "../../../redux/features/cars/carsSlice";

const InstantWinWinBannerAndTab = ({ competitionTypeId }: { competitionTypeId: string }) => {
  const [showInstantWin, setShowInstantWin] = useState(false);
  const [instantWinPrizesWon, setInstantWinPrizesWon] = useState(0);
  const [instantWinPrizesLeft, setInstantWinPrizesLeft] = useState(0);
  const activeTab = useAppSelector(state => state.cars.activeTab);
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      //since we have only one dream car comp, we can use -1 as param, the backend will know it's dreamcar and return data for it
      const response = await getInstantWinData(competitionTypeId, -1);
      const { shouldShowInstantWinTab, prizesWon, prizesLeft } = (await response.json()) as InstantWinProps;
      setShowInstantWin(shouldShowInstantWinTab);
      setInstantWinPrizesWon(prizesWon);
      setInstantWinPrizesLeft(prizesLeft);
    })();
  }, []);

  useEffect(() => {
    updateView();
  }, [activeTab]);

  const updateView = () => {
    if (activeTab === "prizes") {
      showPrizeTabContent();
    } else {
      showInstantWinTabContent();
    }
  };

  return (
    showInstantWin && (
      <>
        <div className={`${styles.dcInstantWinRibbon} ${styles.lgView} py-1 relative flex justify-around`}>
          <img
            src="/assets/images/instant_win/instant-win-160x122.png"
            width={160}
            height={122}
            className="absolute left-48 top-[-35px]"
          />
          <div className="flex font-jost font-medium justify-center items-center">
            <span className="leading-10 mr-4">Every ticket is a chance to win!</span>
            <div className="flex">
              <img
                src="/assets/images/instant_win/tabler-icon-confetti_24x24.png"
                className="mx-4 h-[24px] relative top-[12px]"
              />
              <div className="flex flex-col">
                <span className="prize-counter text-[1.25rem] text-center">{instantWinPrizesWon}</span>
                <span className="text-[0.75rem]">Prizes Won</span>
              </div>
            </div>
            <div className="border-2 border-[rgba(255,255,255,.2)] border-solid mx-4 w-1 h-7"></div>
            <div className="flex">
              <img
                src="/assets/images/instant_win/tabler-icon-trophy_24x24.png"
                className="mx-4 h-[24px] relative top-[12px]"
              />
              <div className="flex flex-col">
                <span className="prize-counter text-[1.25rem] text-center">{instantWinPrizesLeft}</span>
                <span className="text-[0.75rem]">Prizes Left</span>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.dcInstantWinRibbon} ${styles.smView} py-1 relative flex justify-center items-center`}>
          <img
            src="/assets/images/instant_win/instant-win-160x122.png"
            width={120}
            height={90}
            className="absolute left-0"
          />
          <div className="flex font-jost font-medium items-center flex-col ml-12">
            <span className="text-[13px]">Every ticket is a chance to win!</span>
            <div className="flex">
              <div className="flex justify-center items-center">
                <img src="/assets/images/instant_win/tabler-icon-confetti_24x24.png" className="mr-1" />
                <span className="prize-counter text-[13px] text-center">{instantWinPrizesWon}</span>
                <span className="text-[13px] ml-2">Won</span>
              </div>
              <div className="border-2 border-[rgba(255,255,255,.2)] border-solid mx-2 w-1 h-7"></div>
              <div className="flex justify-center items-center">
                <img src="/assets/images/instant_win/tabler-icon-trophy_24x24.png" className="mr-1" />
                <span className="prize-counter text-[13px] text-center">{instantWinPrizesLeft}</span>
                <span className="text-[13px] ml-2">Left</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex text-center">
          <div
            onClick={() => dispatch(publishActiveTab({ value: "prizes" }))}
            className={`xs:basis-1/2 py-10 md:basis-1/6 cursor-pointer font-jost text-[1rem] font-medium hover:text-[#ff8200] ${activeTab === "prizes" ? "border-b-2 border-solid border-[#ff8200] text-[#ff8200]" : "text-[#938994]"}`}>
            PRIZES
          </div>
          <div
            onClick={() => dispatch(publishActiveTab({ value: "instantWin" }))}
            className={`xs:basis-1/2 py-10 md:basis-1/6 cursor-pointer font-jost text-[1rem] font-medium hover:text-[#ff8200] ${activeTab === "instantWin" ? "border-b-2 border-solid border-[#ff8200] text-[#ff8200]" : "text-[#938994]"}`}>
            INSTANT WIN
          </div>
        </div>
      </>
    )
  );
};

export default InstantWinWinBannerAndTab;
